
import { defineComponent } from "vue";
import RoundButton from "@/components/buttons/RoundButton.vue";

export default defineComponent<{}>({
    name: "StandardProjectSuccess",
    components: {
        RoundButton
    }
});
